/* eslint-disable react-hooks/exhaustive-deps */

import moment from "moment";
import { useEffect, useState } from "react";
import type { SuccessFetch } from "types";
import { useApi } from "utils";

type Response = SuccessFetch<{ payload: { empcode: string } }>;

export const useCode = (shift_date: string) => {
  const api = useApi();
  const [data, setData] = useState<string>("-");

  const date = shift_date !== "" ? shift_date : moment().format("YYYY-MM-DD");

  const fetchingData = () => api.get("/employee/schedule-code", { params: { shift_date: date } })

  const fetchData = () => {
    fetchingData()
    .then((res: Response) => {
      setData(res.data.payload.empcode);
    });
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()
  }, [shift_date]);

  return { data, refetch };
};
